exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-row-wrapper[data-v-01fd0016]{display:flex;flex-flow:row nowrap;align-items:stretch}.flex-row-wrapper p[data-v-01fd0016]{font-size:14px}.flex-row-wrapper div:first-child p[data-v-01fd0016]{font-weight:700}.f-3[data-v-01fd0016]{flex:3}.f-5[data-v-01fd0016]{flex:5}", ""]);

// exports
